export default {
  qmulusMaterialSelected: 'Vybrali ste materiál Qmulus. Uložia sa hodnoty analýzy, ale nie názov materiálu.',
  pt9800MaterialSelected: 'Vybrali ste materiál PT9800. Jeho analýzu nie je možné zmeniť.',
};
